import { isStrictApiMockingEnabled } from '@/utils/runtime-mode.utils'

const defaultChannel = {
  id: 'channel_demo_1',
  name: 'Web Chat',
  type: 'chat'
}

const state = {
  organization: {
    id: '7426530691171240939',
    name: 'Amio Local',
    is_active: true
  },
  bots: [
    {
      id: 'bot_demo_1',
      name: 'Footwear Bot',
      timezone: 'Europe/Prague',
      type: 'chat',
      language: 'en',
      country: 'GB',
      multi_bot_id: 'market_group_demo',
      market_id: 'market_en_demo',
      is_primary_variant: true,
      nlp_model: 'gpt',
      nlp_model_type: 'gpt',
      is_operator_available: false,
      unknown_intent: {
        intent_platform_id: 'unknown'
      }
    },
    {
      id: 'bot_demo_2',
      name: 'Footwear Bot',
      timezone: 'Europe/Zurich',
      type: 'chat',
      language: 'fr',
      country: 'CH',
      multi_bot_id: 'market_group_demo',
      market_id: 'market_fr_demo',
      primary_bot_id: 'bot_demo_1',
      nlp_model: 'gpt',
      nlp_model_type: 'gpt',
      is_operator_available: false,
      unknown_intent: {
        intent_platform_id: 'unknown'
      }
    }
  ],
  answersByBotId: {
    bot_demo_1: [
      {
        id: 'a_demo_1',
        bot_id: 'bot_demo_1',
        name: 'Opening hours',
        published: true,
        conversation_id: 'a_demo_1',
        conversation_json_hash: 'hash_demo_1',
        multi_bot_item_id: 'a_demo_1',
        conversation_json: {
          states: {
            root: {
              type: 'output',
              actions: ['action_1'],
              transitions: [
                {
                  state: 'ref:global:findIntent',
                  condition: {
                    input: 'userInput',
                    expression: { true: {} }
                  }
                }
              ]
            }
          },
          actions: {
            action_1: {
              type: 'output',
              content: {
                type: 'text',
                payload: 'Hello from isolated mode'
              }
            }
          },
          postbacks: {}
        },
        intent: {
          id: 'intent_demo_1',
          platform_id: 'intent_demo_1',
          description: 'hello',
          example: 'hello',
          examples_count: 5,
          example_id: 'intent_example_demo_1'
        },
        request_outcome: {
          id: 'outcome_demo_1',
          name: 'AUTOMATED'
        }
      }
    ],
    bot_demo_2: [
      {
        id: 'a_demo_2',
        bot_id: 'bot_demo_2',
        name: 'Opening hours',
        published: false,
        conversation_id: 'a_demo_2',
        conversation_json_hash: 'hash_demo_2',
        multi_bot_item_id: 'a_demo_1',
        inherits_conversation: false,
        conversation_json: {
          states: {
            root: {
              type: 'output',
              actions: ['action_1'],
              transitions: [
                {
                  state: 'ref:global:findIntent',
                  condition: {
                    input: 'userInput',
                    expression: { true: {} }
                  }
                }
              ]
            }
          },
          actions: {
            action_1: {
              type: 'output',
              content: {
                type: 'text',
                payload: 'Bonjour du mode isolé'
              }
            }
          },
          postbacks: {}
        },
        intent: {
          id: 'intent_demo_2',
          platform_id: 'intent_demo_1',
          description: 'bonjour',
          example: 'bonjour',
          examples_count: 5,
          example_id: 'intent_example_demo_2'
        },
        request_outcome: {
          id: 'outcome_demo_1',
          name: 'AUTOMATED'
        }
      }
    ]
  },
  markets: [
    {
      id: 'market_en_demo',
      name: 'UK - EN',
      language: 'en'
    },
    {
      id: 'market_fr_demo',
      name: 'Swiss - FR',
      language: 'fr'
    }
  ],
  multiBots: [
    {
      id: 'market_root_demo',
      name: 'UK - EN',
      is_primary_variant: true,
      primary_bot_id: 'bot_demo_1',
      primary_bot: {
        id: 'bot_demo_1',
        multi_bot_id: 'market_group_demo',
        market_id: 'market_en_demo'
      }
    },
    {
      id: 'market_fr_demo',
      name: 'Swiss - FR',
      is_primary_variant: false,
      primary_bot_id: 'bot_demo_2',
      primary_bot: {
        id: 'bot_demo_2',
        multi_bot_id: 'market_group_demo',
        market_id: 'market_fr_demo'
      }
    }
  ],
  deploymentsByBotId: {
    bot_demo_1: [
      {
        channel: defaultChannel
      }
    ],
    bot_demo_2: [
      {
        channel: defaultChannel
      }
    ]
  }
}

function parseUrlParts(rawUrl = '') {
  const parsed = new URL(rawUrl, 'http://localhost')
  return {
    path: parsed.pathname,
    query: parsed.searchParams
  }
}

function buildResponse(config, data, status = 200) {
  return {
    data,
    status,
    statusText: status >= 400 ? 'Error' : 'OK',
    headers: {},
    config,
    request: { mocked: true }
  }
}

function readPayload(config) {
  if (!config || config.data == null) return {}

  if (typeof config.data === 'string') {
    try {
      return JSON.parse(config.data)
    } catch (err) {
      return {}
    }
  }
  return config.data
}

function deepClone(value) {
  return JSON.parse(JSON.stringify(value))
}

function buildError(config, message, status = 500) {
  const error = new Error(message)
  error.config = config
  error.response = {
    status,
    data: {
      errors: [{ message }]
    },
    config
  }
  return error
}

function findBot(botId) {
  return state.bots.find(bot => bot.id === botId)
}

function listBots() {
  return state.bots.map(bot => ({ ...bot }))
}

function listMultiBots() {
  return state.multiBots.map(multiBot => deepClone(multiBot))
}

function listMarkets() {
  return state.markets.map(market => ({ ...market }))
}

function listAnswers(botId) {
  return (state.answersByBotId[botId] || []).map(answer => deepClone(answer))
}

function getAnswer(botId, answerId) {
  const answers = state.answersByBotId[botId] || []
  const answer = answers.find(item => item.id === answerId)
  return answer ? deepClone(answer) : null
}

function listAnswerVariants(botId, answerId) {
  const sourceAnswer = getAnswer(botId, answerId)
  if (!sourceAnswer) return []

  const multiBotItemId = sourceAnswer.multi_bot_item_id || sourceAnswer.id

  return Object.values(state.answersByBotId)
    .flat()
    .filter(answer => (answer.multi_bot_item_id || answer.id) === multiBotItemId)
    .map(answer => deepClone(answer))
}

function updateAnswer(botId, answerId, patchData = {}) {
  const answers = state.answersByBotId[botId] || []
  const index = answers.findIndex(item => item.id === answerId)
  if (index === -1) return null

  const answer = answers[index]
  const updated = { ...answer }

  if (patchData.name !== undefined) updated.name = patchData.name
  if (patchData.published !== undefined) updated.published = patchData.published
  if (patchData.conversation_json !== undefined) {
    updated.conversation_json = deepClone(patchData.conversation_json)
    updated.conversation_json_hash = patchData.conversation_json_hash || `hash_${Date.now()}`
  }

  answers[index] = updated
  state.answersByBotId[botId] = answers
  return deepClone(updated)
}

function createAnswer(botId, payload = {}) {
  const id = `a_demo_${Date.now()}`
  const intentId = `intent_demo_${Date.now()}`
  const conversationJson = payload.conversation_json || {
    states: {},
    actions: {},
    postbacks: {}
  }

  const answer = {
    id,
    name: payload.name || 'New Answer',
    published: false,
    conversation_id: id,
    conversation_json_hash: `hash_${Date.now()}`,
    conversation_json: conversationJson,
    intent: {
      id: intentId,
      platform_id: intentId,
      description: '',
      example: '',
      examples_count: 0,
      example_id: `intent_example_${Date.now()}`
    },
    request_outcome: {
      id: 'outcome_demo_1',
      name: 'AUTOMATED'
    }
  }

  const answers = state.answersByBotId[botId] || []
  answers.unshift(answer)
  state.answersByBotId[botId] = answers
  return deepClone(answer)
}

function getIntent(intentId) {
  for (const answers of Object.values(state.answersByBotId)) {
    const answer = answers.find(item => item.intent?.id === intentId)
    if (answer) return deepClone(answer.intent)
  }
  return null
}

function updateIntent(intentId, patchData = {}) {
  for (const botId of Object.keys(state.answersByBotId)) {
    const answers = state.answersByBotId[botId]
    const index = answers.findIndex(item => item.intent?.id === intentId)
    if (index === -1) continue

    const updatedIntent = {
      ...answers[index].intent
    }
    if (patchData.description !== undefined) updatedIntent.description = patchData.description
    if (patchData.example !== undefined) updatedIntent.example = patchData.example

    answers[index] = {
      ...answers[index],
      intent: updatedIntent
    }
    state.answersByBotId[botId] = answers
    return deepClone(updatedIntent)
  }
  return null
}

function upsertBot(botId, patchData = {}) {
  const index = state.bots.findIndex(bot => bot.id === botId)
  if (index === -1) return null
  state.bots[index] = { ...state.bots[index], ...patchData }
  return { ...state.bots[index] }
}

function removeBot(botId) {
  const index = state.bots.findIndex(bot => bot.id === botId)
  if (index === -1) return false
  state.bots.splice(index, 1)
  delete state.deploymentsByBotId[botId]
  delete state.answersByBotId[botId]
  return true
}

function createBotFromPayload(payload = {}) {
  const primaryVariant = payload.primary_variant || {}
  const timezone = primaryVariant.timezone || payload.timezone || 'Europe/Prague'
  const type = primaryVariant.type || payload.type || 'chat'
  const language = primaryVariant.language || payload.language || 'en'
  const nlpModelType = primaryVariant.nlp_model_type || payload.nlp_model_type || 'gpt'
  const id = `bot_${Date.now()}`
  const bot = {
    id,
    name: payload.name || 'New Bot',
    timezone,
    type,
    language,
    country: primaryVariant.country || payload.country,
    nlp_model: nlpModelType
  }
  state.bots.unshift(bot)
  state.deploymentsByBotId[id] = []
  return { ...bot }
}

function listDeployments(botId) {
  return (state.deploymentsByBotId[botId] || []).map(item => ({ ...item }))
}

function addDeployment(botId, channelId) {
  const list = state.deploymentsByBotId[botId] || []
  const exists = list.some(item => item.channel.id === channelId)
  if (!exists) {
    list.push({
      channel: {
        id: channelId,
        name: `Channel ${channelId}`,
        type: 'chat'
      }
    })
  }
  state.deploymentsByBotId[botId] = list
  return listDeployments(botId)
}

function createDeployment(botId, payload = {}) {
  const channelId = `channel_${Date.now()}`
  const channelName = payload.name || `Channel ${channelId}`
  const channelType = payload.type || 'amio_chat'
  const list = state.deploymentsByBotId[botId] || []
  const deployment = {
    channel: {
      id: channelId,
      name: channelName,
      type: channelType
    }
  }
  list.push(deployment)
  state.deploymentsByBotId[botId] = list
  return { ...deployment }
}

function removeDeployment(botId, channelId) {
  const list = state.deploymentsByBotId[botId] || []
  state.deploymentsByBotId[botId] = list.filter(item => item.channel.id !== channelId)
}

function handleOrgApi(config, method, path) {
  if (method === 'get' && path === '/organizations') {
    return buildResponse(config, state.organization)
  }
  return null
}

function handleEngineApi(config, method, path, query) {
  if (method === 'get' && path === '/bots') {
    return buildResponse(config, listBots())
  }

  if (method === 'get' && path === '/variables') {
    return buildResponse(config, [])
  }

  const intentMatch = path.match(/^\/intents\/([^/]+)$/)
  if (intentMatch) {
    const intentId = intentMatch[1]
    if (method === 'get') {
      const intent = getIntent(intentId)
      if (!intent) throw buildError(config, `Mock intent not found: ${intentId}`, 404)
      return buildResponse(config, intent)
    }
    if (method === 'patch') {
      const updatedIntent = updateIntent(intentId, readPayload(config))
      if (!updatedIntent) throw buildError(config, `Mock intent not found: ${intentId}`, 404)
      return buildResponse(config, updatedIntent)
    }
  }

  const botMatch = path.match(/^\/bots\/([^/]+)$/)
  if (botMatch) {
    const botId = botMatch[1]
    if (method === 'get') {
      const bot = findBot(botId)
      if (!bot) throw buildError(config, `Mock bot not found: ${botId}`, 404)
      return buildResponse(config, { ...bot })
    }
    if (method === 'patch') {
      const updated = upsertBot(botId, readPayload(config))
      if (!updated) throw buildError(config, `Mock bot not found: ${botId}`, 404)
      return buildResponse(config, updated)
    }
    if (method === 'delete') {
      if (!removeBot(botId)) throw buildError(config, `Mock bot not found: ${botId}`, 404)
      return buildResponse(config, {}, 204)
    }
  }

  if (method === 'post' && path === '/bots') {
    return buildResponse(config, createBotFromPayload(readPayload(config)), 201)
  }

  if (method === 'get' && path === '/markets') {
    return buildResponse(config, listMarkets())
  }

  if (method === 'post' && path === '/markets') {
    const payload = readPayload(config)
    return buildResponse(config, {
      id: `market_${Date.now()}`,
      name: payload.name,
      language: payload.language
    }, 201)
  }

  if (method === 'post' && path === '/multi-bots') {
    return buildResponse(config, createBotFromPayload(readPayload(config)), 201)
  }

  if (method === 'get' && path === '/multi-bots') {
    return buildResponse(config, listMultiBots())
  }

  const cloneMatch = path.match(/^\/bots\/([^/]+)\/clone$/)
  if (cloneMatch && method === 'post') {
    const sourceBotId = cloneMatch[1]
    const sourceBot = findBot(sourceBotId)
    if (!sourceBot) throw buildError(config, `Mock source bot not found: ${sourceBotId}`, 404)

    const payload = readPayload(config)
    return buildResponse(config, createBotFromPayload({
      ...sourceBot,
      ...payload,
      type: sourceBot.type
    }), 201)
  }

  const deploymentsMatch = path.match(/^\/bots\/([^/]+)\/deployments$/)
  if (deploymentsMatch) {
    const botId = deploymentsMatch[1]
    if (method === 'get') return buildResponse(config, listDeployments(botId))
    if (method === 'post') {
      const payload = readPayload(config)
      return buildResponse(config, createDeployment(botId, payload), 201)
    }
    if (method === 'put') {
      const payload = readPayload(config)
      const channelId = payload.channel_id
      if (!channelId) throw buildError(config, 'Mock deployment requires channel_id', 400)
      return buildResponse(config, addDeployment(botId, channelId))
    }
    if (method === 'delete') {
      const channelId = query.get('channelId')
      if (!channelId) throw buildError(config, 'Mock deployment delete requires channelId query', 400)
      removeDeployment(botId, channelId)
      return buildResponse(config, {}, 204)
    }
  }

  const templatesMatch = path.match(/^\/bots\/([^/]+)\/templates$/)
  if (templatesMatch && method === 'get') {
    return buildResponse(config, [])
  }

  const answersMatch = path.match(/^\/bots\/([^/]+)\/answers$/)
  if (answersMatch && method === 'get') {
    const botId = answersMatch[1]
    return buildResponse(config, listAnswers(botId))
  }
  if (answersMatch && method === 'post') {
    const botId = answersMatch[1]
    const created = createAnswer(botId, readPayload(config))
    return buildResponse(config, created, 201)
  }

  const answerDetailMatch = path.match(/^\/bots\/([^/]+)\/answers\/([^/]+)$/)
  if (answerDetailMatch && method === 'get') {
    const botId = answerDetailMatch[1]
    const answerId = answerDetailMatch[2]
    const answer = getAnswer(botId, answerId)
    if (!answer) throw buildError(config, `Mock answer not found: ${answerId}`, 404)
    return buildResponse(config, answer)
  }
  if (answerDetailMatch && method === 'patch') {
    const botId = answerDetailMatch[1]
    const answerId = answerDetailMatch[2]
    const payload = readPayload(config)
    const updated = updateAnswer(botId, answerId, payload)
    if (!updated) throw buildError(config, `Mock answer not found: ${answerId}`, 404)
    return buildResponse(config, updated)
  }

  const answerVariantsMatch = path.match(/^\/bots\/([^/]+)\/answers\/([^/]+)\/variants$/)
  if (answerVariantsMatch && method === 'get') {
    const botId = answerVariantsMatch[1]
    const answerId = answerVariantsMatch[2]
    return buildResponse(config, listAnswerVariants(botId, answerId))
  }

  const answerReferencedConversationsMatch = path.match(/^\/bots\/([^/]+)\/answers\/([^/]+)\/referenced-conversations$/)
  if (answerReferencedConversationsMatch && method === 'get') {
    return buildResponse(config, {})
  }

  const variablesMatch = path.match(/^\/bots\/([^/]+)\/variables$/)
  if (variablesMatch && method === 'put') {
    return buildResponse(config, { refs: readPayload(config) })
  }

  return null
}

function handleCommunicatorApi(config) {
  throw buildError(config, 'Communicator mock route not implemented yet', 501)
}

export function createMockAdapter(config, clientName) {
  const method = (config.method || 'get').toLowerCase()
  const { path, query } = parseUrlParts(config.url || '')
  const strict = isStrictApiMockingEnabled()

  let response = null
  if (clientName === 'org') response = handleOrgApi(config, method, path, query)
  if (clientName === 'engine') response = handleEngineApi(config, method, path, query)
  if (clientName === 'communicator') response = handleCommunicatorApi(config, method, path, query)

  if (response) return response
  if (!strict) return null

  throw buildError(
    config,
    `Missing API mock for [${clientName}] ${method.toUpperCase()} ${path}`,
    501
  )
}
